import {
  Container,
  ListContainer,
  StyledIndex,
  StyledParagraph,
  Title,
} from './styles';
import { LinkItem, SortedDisclaimer, TranslationProps } from './types';

interface DisclaimersProps {
  disclaimerTitle: string;
  sortedDisclaimers: SortedDisclaimer[];
  TranslationWrapperComponent: React.ComponentType<TranslationProps>;
  translationComponents?: LinkItem;
}

export const Disclaimers: React.FC<DisclaimersProps> = (props) => {
  const {
    disclaimerTitle,
    sortedDisclaimers,
    TranslationWrapperComponent,
    translationComponents,
  } = props;
  return (
    <Container id="disclaimers">
      <Title className="title-regular">{disclaimerTitle}</Title>
      {sortedDisclaimers.map(({ key, value }, index) => (
        <ListContainer key={key}>
          <StyledIndex className="caption-regular">{`${index + 1}. `}</StyledIndex>
          <StyledParagraph className="caption-regular">
            <TranslationWrapperComponent
              i18nKey={value}
              links={translationComponents}
              linkStyle={'blue'}
            />
          </StyledParagraph>
        </ListContainer>
      ))}
    </Container>
  );
};
